// artifacts: что может выпасть из разрушенного (зеркало server/internal/game/
// artifacts.go) — модель, цвет свечения, подпись для всплывающей подсказки.

import { PickupType } from "../net/protocol";
import { weaponDef, weaponFromPickupType } from "../weapons/catalog";
import { t } from "../i18n";

export interface ArtifactDef {
  /** Модель /models/artifacts/<model>.glb и иконка icons/<model>.png; "" — оружие (своя модель). */
  model: string;
  /** Название в подсказке. */
  title: string;
  /** Цвет свечения (линейный RGB). */
  glow: [number, number, number];
  /** Реликвия (серебро). */
  relic: boolean;
  /** Половина высоты модели (м, до масштаба). */
  lift: number;
  /** Масштаб показа: предметы нарочно крупнее жизни, чтобы читались издалека. */
  scale: number;
}

const DEFS: Record<number, ArtifactDef> = {
  [PickupType.Ammo]: { model: "art_ammo", title: "Ящик патронов", glow: [1.0, 0.72, 0.28], relic: false, lift: 0.21, scale: 1.3 },
  [PickupType.Medkit]: { model: "art_medkit", title: "Саквояж врача", glow: [0.95, 0.55, 0.5], relic: false, lift: 0.2, scale: 1.3 },
  [PickupType.RelicMedallion]: { model: "relic_medallion", title: "Рубиновый медальон", glow: [1.0, 0.3, 0.26], relic: true, lift: 0.15, scale: 1.7 },
  [PickupType.RelicSkull]: { model: "relic_skull", title: "Череп-амулет", glow: [0.35, 1.0, 0.45], relic: true, lift: 0.15, scale: 1.7 },
  [PickupType.RelicCrystal]: { model: "relic_crystal", title: "Лунный кристалл", glow: [0.72, 0.42, 1.0], relic: true, lift: 0.2, scale: 1.5 },
};

/** Описание артефакта по типу pickup'а (оружие — по каталогу оружия). */
export function artifactDef(type: number): ArtifactDef | null {
  const d = DEFS[type];
  if (d) return d;
  const w = weaponFromPickupType(type);
  if (w >= 0) {
    const wd = weaponDef(w);
    return { model: "", title: wd.title, glow: wd.glow, relic: false, lift: 0.2, scale: 1 };
  }
  return null;
}

export function isRelicType(type: number): boolean {
  return type === PickupType.RelicMedallion || type === PickupType.RelicSkull || type === PickupType.RelicCrystal;
}

/** «серебра» по числу: 1 серебро, 2 серебра, 5 серебра — у слова одна форма. */
export function silverText(n: number): string {
  return t("+{n} серебра", { n });
}

export const ARTIFACT_MODELS = ["art_ammo", "art_medkit", "relic_medallion", "relic_skull", "relic_crystal"];
